import { Typography } from '@mui/material'
import React from 'react'
import useStyles from './Styles'
import { Box } from '@mui/system'
import { Grid } from '@mui/material'
import social from 'src/assets/images/dtlOriginals/social.png'
import Youtube from 'src/assets/svgs/dtlOriginals/Youtube'
import Instagram from 'src/assets/svgs/dtlOriginals/Instagram'
import Tiktok from 'src/assets/svgs/dtlOriginals/Tiktok'

import Image from 'next/image'
import { getCookie } from 'cookies-next'
interface Props {
  zenMode: boolean
}
function SocialMedia(props: Props) {
  const { zenMode } = props
  const { classes } = useStyles()
  const isBrowser = typeof window === 'object' ? true : false
  const lang = getCookie('lang')

  return (
    <Box
      className={!zenMode ? classes.container : classes.containerZenMode}
      mb={0}
    >
      <Grid container>
        <Grid
          item
          md={8}
          pl={{ md: 15, sm: 10, xs: 4 }}
          pr={{ md: 0, sm: 10, xs: 4 }}
        >
          <Typography className={classes.heading}>
            {isBrowser && lang === 'En'
              ? 'Follow our socials'
              : 'Síguenos en las redes sociales'}
          </Typography>
          <Typography className={classes.text}>
            {isBrowser && lang === 'En'
              ? 'Keep yourself updated with new trends and news updates follow our social accounts'
              : 'Manténgate actualizadx de las nuevas tendencias y noticias siga nuestras cuentas en las redes sociales'}
          </Typography>
          <Box className={classes.iconsWrapper}>
            <a
              href={
                isBrowser && lang === 'En'
                  ? 'https://www.youtube.com/channel/UCi3XXcjqUFbF78ZMjVxq9ag'
                  : 'https://www.youtube.com/@QuitatelasEtiquetas'
              }
              target="_blank"
              rel="noreferrer"
            >
              {' '}
              <div>
                <Youtube />
              </div>
              <p>YOUTUBE</p>
            </a>
            <a
              href="https://www.tiktok.com/@ditchthelabel?lang=en"
              target="_blank"
              rel="noreferrer"
            >
              {' '}
              <div>
                <Tiktok />
              </div>
              <p>Tiktok</p>
            </a>
            <a
              href={
                isBrowser && lang === 'En'
                  ? 'https://www.instagram.com/ditchthelabel/?hl=en'
                  : 'https://www.instagram.com/quitatelasetiquetas/'
              }
              target="_blank"
              rel="noreferrer"
            >
              {' '}
              <div>
                <Instagram />
              </div>
              <p>Instagram</p>
            </a>
          </Box>
        </Grid>
        <Grid
          item
          md={4}
          sm={4}
          xs={12}
          // pr={{ md: 15, sm: 6, xs: 6 }}
          // pl={{ md: 0, sm: 6, xs: 6 }}
          // pt={{ md: 0, sm: 10, xs: 6 }}
        >
          <div className={classes.img}>
            <Image src={social} alt="" />
          </div>
        </Grid>
      </Grid>
    </Box>
  )
}

export default SocialMedia
